import AlertasLayout from './AlertasLayout.vue';
import NotificacionesPage from './notificaciones/NotificacionesPage.vue';
 import SuscripcionesPage from './suscripciones/SuscripcionesPage.vue';

export const alertasRoutes = {
  path: 'alertas',
  component: AlertasLayout,
  children: [
    {
      path: 'notificaciones',
      name: 'Notificaciones',
      component: NotificacionesPage ,
      meta: {
        moduleAccess: 'Alertas'
      }         
    },
    {
      path: 'suscripciones',
      name: 'Suscripciones',
      component: SuscripcionesPage  ,
      meta: {
        moduleAccess: 'Alertas'
      }        
    }
  ],
  meta: {
    moduleAccess: 'Alertas',
    requireAuth: true,
    title: 'nav_bar.example'
  }
};